import React from "react";

import { Product } from "@greeter/core";
import { PageContainer, ProductCard, RoundedButton } from "@greeter/matter";
import { doNothing } from "@greeter/util";
import { IonContent, IonPage } from "@ionic/react";
import { SkeletonRect } from "@greeter-venue/components/SkeletonRect";
import { Slip } from "@greeter-venue/components/Slip";
import { WhiteRoundedButton } from "@greeter-venue/components/WhiteRoundedButton";
import { Link, useHistory } from "react-router-dom";
import { Routes } from "@greeter-venue/utility/Routes";
import { classNames, Loadable } from "@greeter-venue/utility";

import css from "./ProductCreatedPage.module.scss";

const SlipContent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={css.SlipContent}>{children}</div>;
};

export type ProductCreatedPageProps = {
  product: Loadable<Product>;
  onCreateAnother?: () => void;
};

export const ProductCreatedPage: React.FC<ProductCreatedPageProps> = ({
  product,
  onCreateAnother = doNothing,
}) => {
  const history = useHistory();

  return (
    <IonPage>
      <IonContent>
        <PageContainer>
          <Slip {...classNames(css.Slip)}>
            <SlipContent>
              <h1 style={{ fontWeight: "bold" }}>Sådan! Pakken er oprettet</h1>
              {product === "loading" ? (
                <SkeletonRect width="8rem" height="10rem" />
              ) : (
                <ProductCard product={product} />
              )}
              <WhiteRoundedButton
                onClick={() =>
                  history.push(Routes.mainGroup.venueTab.product.route())
                }
              >
                Opret endnu en pakke
              </WhiteRoundedButton>
              <Link
                to={Routes.mainGroup.venueTab.root.route()}
                {...classNames(css.FinishButton)}
              >
                Afslut
              </Link>
              <div style={{ fontSize: "0.8rem" }}>
                Brugerne kan nu finde og købe pakken.
                <br />
                Hold øje med dine ordrer på venuesiden.
              </div>
            </SlipContent>
          </Slip>
        </PageContainer>
      </IonContent>
    </IonPage>
  );
};
